const getters = {
  loading: state => {
    return state.loading
  },
  searchResult: state => {
    return state.searchResult
  },
  searchInvitationsResult: state => {
    return state.searchInvitationsResult
  },
  systemOwnerList: state => {
    return state.systemOwnerList.items
  },
  agencyList: state => {
    return state.agencyList.items
  },
  advertiserList: state => {
    return state.advertiserList.items
  },
  agencyListForSearch: state => {
    return state.agencyListForSearch.items
  },
  advertiserListForSearch: state => {
    return state.advertiserListForSearch.items
  },
}

export default getters
